module.exports = __webpack_public_path__ + "img/imageAdd1.bc67f26d.jpg";